export class LogoSummary {
  total: number

  constructor(data: any = {}) {
    Object.assign(this, data)
  }
}
